/* eslint-disable camelcase */
import { PageEvents, ProductEvents } from 'libs/Events/constants';
import { RESOLVE_SLUG, RESOLVE_SLUG_ERROR, RESOLVE_SLUG_SUCCESS } from './constants';

import Events from 'libs/Events';
import { ResolveSlug } from 'libs/GrebbCommerceAPI/Content';
import { extractQueryParams } from 'utils/query';
import { inServer } from 'config/constants';

/**
 * The preview token comes from ?preview=... on the first request. It is kept in the application
 * state so it survives client side navigation and the editor can browse the site in preview mode.
 */
const getPreviewToken = applicationState => {
    const tokenFromInitialQuery = applicationState.initialQueryObject && applicationState.initialQueryObject.preview;

    if (tokenFromInitialQuery) {
        return tokenFromInitialQuery;
    }

    if (inServer) {
        return null;
    }

    // Client only rendering (yarn start) never sets the initial query.
    return extractQueryParams(window.location.search).preview || null;
};

export const resolveSlug = (slug, parameters = {}) => async (dispatch, getState) => {
    const applicationState = getState().application;
    const { applicationId } = applicationState;

    if (!applicationId) {
        return null;
    }

    const previewToken = getPreviewToken(applicationState);
    const resolveParameters = previewToken ? { ...parameters, preview: previewToken } : parameters;

    dispatch({ type: RESOLVE_SLUG });

    try {
        const response = await ResolveSlug(applicationId, slug, resolveParameters);

        if (slug === '/debug') {
            // We need to resolve a promise in this function becaouse its async
            // for the debugts route to work.
            await new Promise(resolve => resolve());
            dispatch({
                type: RESOLVE_SLUG_SUCCESS,
                pageData: {},
                pageType: 'debug',
            });
            return false;
        }

        if (response.status === 200) {
            dispatch({
                type: RESOLVE_SLUG_SUCCESS,
                pageSlug: response.data.permalink,
                pageData: response.data.data,
                pageType: response.data.type,
                pageTemplate: response.data.template,
                pageRelationships: response.data.relationships,
                isPreview: !!response.data.preview,
            });
        } else if (response.status === 301 || response.status === 302) {
            dispatch({
                type: RESOLVE_SLUG_SUCCESS,
                pageData: {
                    to: response.data.to,
                    status: response.status,
                },
                pageType: 'redirect',
            });

            return response;
        } else if (response.status === 404) {
            dispatch({
                type: RESOLVE_SLUG_SUCCESS,
                pageData: (response.data || {}).data || {},
                pageType: 'not_found',
            });
            return false;
        } else {
            throw response.error;
        }

        Events.trigger(PageEvents.VIEW, { application: getState().application, page: getState().page });

        if (response.data.type === 'product' && response.data.data) {
            const product = response.data.data;

            Events.trigger(ProductEvents.VIEW, {
                product: {
                    name: product?.name,
                    sku: product?.sku,
                    price: product?.price?.price,
                    salePrice: product?.price?.sale_price,
                    categories: product?.categories,
                },
            });
        }

        return response;
    } catch (e) {
        dispatch({ type: RESOLVE_SLUG_ERROR });
        throw e;
    }
};
